import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useGlobal } from '@rcg/ui-react';
import { IS_LOGGED_IN } from './graphql/queries';

import routeUser from './Navigation';
import { LDUser } from './commons/ld-user';

const App = () => {
  const GLOBALS = useGlobal();
  const { loading, error, data } = useQuery(IS_LOGGED_IN);

  useEffect(() => {
    // Initialize RWD_ID on application startup
    LDUser();
  }, []);

  if (loading || GLOBALS.loading) return <p />;
  if (error || GLOBALS.error) return <p>Error</p>;
  return routeUser(data, GLOBALS);
};

export default App;
